import {createRouter, createWebHistory} from 'vue-router'
import store from "@/store";
import SpeakerPage from "@/pages/master/SpeakerPage.vue";
import SpeakerEditPage from "@/pages/master/SpeakerEditPage.vue";
import DashboardPage from "@/pages/dashboard/DashboardPage.vue";
import Report from "@/pages/report/Report.vue";
import SessionParticipationReport from "@/pages/report/SessionParticipationReport.vue";
import Events from "@/pages/event/EventPage.vue";
import EventDetail from "@/pages/event/EventDetail.vue";
import EventActive2 from "@/pages/event/EventActive2.vue";
import User from "@/pages/account/User.vue";
import Role from "@/pages/account/Role.vue";
import Sponsor from "@/pages/master/SponsorPage.vue";
import SponsorEditPage from "@/pages/master/SponsorEditPage.vue";
import ExhibitorPage from "@/pages/master/ExhibitorPage.vue";
import ExhibitorEditPage from "@/pages/master/ExhibitorEditPage.vue";
import MemberPage from "@/pages/master/MemberPage.vue";
import MemberSyncPage from "@/pages/master/MemberSyncPage.vue";
import MemberAddPage from "@/pages/master/MemberAddPage.vue";
import MemberImportPage from "@/pages/master/MemberImportPage.vue";
import EventEditPage from "@/pages/event/EventEditPage.vue";
import MemberEditPage from "@/pages/master/MemberEditPage.vue";
import SponsorAddPage from "@/pages/master/SponsorAddPage.vue";
import EventAddPage from "@/pages/event/EventAddPage.vue";
import ExhibitorAddPage from "@/pages/master/ExhibitorAddPage.vue";
import SpeakerAddPage from "@/pages/master/SpeakerAddPage.vue";
import LoginPage from "@/pages/LoginPage.vue";
import EventDetailQuestionPage from "@/pages/event/EventDetailQuestionPage.vue";
import QuestionPage from "@/pages/quiz/QuestionPage.vue";
import QuestionEditPage from "@/pages/quiz/QuestionEditPage.vue";
import QuestionAddPage from "@/pages/quiz/QuestionAddPage.vue";
import QuizPage from "@/pages/quiz/QuizPage.vue";
import QuizEditPage from "@/pages/quiz/QuizEditPage.vue";
import QuizAddPage from "@/pages/quiz/QuizAddPage.vue";
import QuizActivePage from "@/pages/quiz/QuizActivePage.vue";
import GeneralSettingEditPage  from "@/pages/setting/GeneralSettingEditPage.vue";
import EventDetailEditPage from "@/pages/event/EventDetailEditPage.vue";
import EventDetailAddPage from "@/pages/event/EventDetailAddPage.vue";
import PlacePage from "@/pages/master/PlacePage.vue";
import PlaceEditPage from "@/pages/master/PlaceEditPage.vue";
import PlaceAddPage from "@/pages/master/PlaceAddPage.vue";
import BroadcastNotificationAddPage from "@/pages/message/BroadcastNotificationAddPage.vue";
import PhotoGalleryPage from "@/pages/photo-gallery/PhotoGalleryPage.vue";
import PhotoGalleryAddPage from '@/pages/photo-gallery/PhotoGalleryAddPage.vue';
import VideoGalleryPage from '@/pages/video-gallery/VideoGalleryPage.vue';
import VideoGalleryAddPage from '@/pages/video-gallery/VideoGalleryAddPage.vue';
import VideoGalleryEditPage from '@/pages/video-gallery/VideoGalleryEditPage.vue';

const routes = [
    {
        path: '/',
        name: 'Home',
        component: DashboardPage,
        meta: {
            layout: 'main'
        }
    },
    {
        path: '/dashboard',
        name: 'Dashboard',
        component: DashboardPage,
        meta: {
            layout: 'main'
        }
    },
    {
        path: '/report',
        name: 'Report',
        component: Report,
        meta: {
            layout: 'main'
        }
    },
    {
        path: '/report/session-participation',
        name: 'SessionParticipationReport',
        component: SessionParticipationReport,
        meta: {
            layout: 'main'
        }
    },
    {
        path: '/speaker',
        name: 'Speaker',
        component: SpeakerPage,
        meta: {
            layout: 'main'
        }
    },
    {
        path: '/speaker/edit/:id',
        name: 'SpeakerEdit',
        component: SpeakerEditPage,
        meta: {
            layout: 'main'
        }
    },
    {
        path: '/speaker/add',
        name: 'SpeakerAdd',
        component: SpeakerAddPage,
        meta: {
            layout: 'main'
        }
    },
    {
        path: '/member',
        name: 'Member',
        component: MemberPage,
        meta: {
            layout: 'main'
        }
    },
    {
        path: '/member/sync',
        name: 'MemberSync',
        component: MemberSyncPage,
        meta: {
            layout: 'main'
        }
    },
    {
        path: '/member/add',
        name: 'MemberAdd',
        component: MemberAddPage,
        meta: {
            layout: 'main'
        }
    },
    {
        path: '/member/import',
        name: 'MemberImport',
        component: MemberImportPage,
        meta: {
            layout: 'main'
        }
    },
    {
        path: '/member/edit/:id',
        name: 'MemberEdit',
        component: MemberEditPage,
        meta: {
            layout: 'main'
        }
    },
    {
        path: '/event-active',
        name: 'EventActive2',
        component: EventActive2,
        meta: {
            layout: 'main'
        }
    },
    {
        path: '/event',
        name: 'Events',
        component: Events,
        meta: {
            layout: 'main'
        }
    },
    {
        path: '/event/edit/:id',
        name: 'EventEdit',
        component: EventEditPage,
        meta: {
            layout: 'main'
        }
    },
    {
        path: '/event/add',
        name: 'EventAdd',
        component: EventAddPage,
        meta: {
            layout: 'main'
        }
    },
    {
        path: '/event-detail',
        name: 'EventDetail',
        component: EventDetail,
        meta: {
            layout: 'main'
        }
    },
    {
        path: '/event-detail/edit/:id',
        name: 'EventDetailEdit',
        component: EventDetailEditPage,
        meta: {
            layout: 'main'
        }
    },
    {
        path: '/event-detail/add',
        name: 'EventDetailAdd',
        component: EventDetailAddPage,
        meta: {
            layout: 'main'
        }
    },
    {
        path: '/forum-question',
        name: 'EventDetailQuestion',
        component: EventDetailQuestionPage,
        meta: {
            layout: 'main'
        }
    },
    {
        path: '/photo-gallery',
        name: 'PhotoGalleryPage',
        component: PhotoGalleryPage,
        meta: {
            layout: 'main'
        }
    },
    {
        path: '/photo-gallery/add',
        name: 'PhotoGalleryAddPage',
        component: PhotoGalleryAddPage,
        meta: {
            layout: 'main'
        }
    },
    {
        path: '/video-gallery',
        name: 'VideoGalleryPage',
        component: VideoGalleryPage,
        meta: {
            layout: 'main'
        }
    },
    {
        path: '/video-gallery/add',
        name: 'VideoGalleryAddPage',
        component: VideoGalleryAddPage,
        meta: {
            layout: 'main'
        }
    },
    {
        path: '/video-gallery/edit/:id',
        name: 'VideoGalleryEditPage',
        component: VideoGalleryEditPage,
        meta: {
            layout: 'main'
        }
    },
    {
        path: '/sponsor',
        name: 'Sponsor',
        component: Sponsor,
        meta: {
            layout: 'main'
        }
    },
    {
        path: '/sponsor/edit/:id',
        name: 'SponsorEdit',
        component: SponsorEditPage,
        meta: {
            layout: 'main'
        }
    },
    {
        path: '/sponsor/add',
        name: 'SponsorAdd',
        component: SponsorAddPage,
        meta: {
            layout: 'main'
        }
    },
    {
        path: '/exhibitor',
        name: 'Exhibitor',
        component: ExhibitorPage,
        meta: {
            layout: 'main'
        }
    },
    {
        path: '/exhibitor/edit/:id',
        name: 'ExhibitorEdit',
        component: ExhibitorEditPage,
        meta: {
            layout: 'main'
        }
    },
    {
        path: '/exhibitor/add',
        name: 'ExhibitorAdd',
        component: ExhibitorAddPage,
        meta: {
            layout: 'main'
        }
    },
    {
        path: '/user',
        name: 'User',
        component: User,
        meta: {
            layout: 'main'
        }
    },
    {
        path: '/role',
        name: 'Role',
        component: Role,
        meta: {
            layout: 'main'
        }
    },
    {
        path: '/quiz/question',
        name: 'Question',
        component: QuestionPage,
        meta: {
            layout: 'main'
        }
    },
    {
        path: '/quiz/question/edit/:id',
        name: 'QuestionEdit',
        component: QuestionEditPage,
        meta: {
            layout: 'main'
        }
    },
    {
        path: '/quiz/question/add',
        name: 'QuestionAdd',
        component: QuestionAddPage,
        meta: {
            layout: 'main'
        }
    },
    {
        path: '/quiz/active',
        name: 'QuizActive',
        component: QuizActivePage,
        meta: {
            layout: 'quiz-active'
        }
    },
    {
        path: '/quiz',
        name: 'Quiz',
        component: QuizPage,
        meta: {
            layout: 'main'
        }
    },
    {
        path: '/quiz/edit/:id',
        name: 'QuizEdit',
        component: QuizEditPage,
        meta: {
            layout: 'main'
        }
    },
    {
        path: '/quiz/add',
        name: 'QuizAdd',
        component: QuizAddPage,
        meta: {
            layout: 'main'
        }
    },
    {
        path: '/general-setting',
        name: 'GeneralSettingEdit',
        component: GeneralSettingEditPage,
        meta: {
            layout: 'main'
        }
    },
    {
        path: '/place',
        name: 'Place',
        component: PlacePage,
        meta: {
            layout: 'main'
        }
    },
    {
        path: '/place/edit/:id',
        name: 'PlaceEdit',
        component: PlaceEditPage,
        meta: {
            layout: 'main'
        }
    },
    {
        path: '/place/add',
        name: 'PlaceAdd',
        component: PlaceAddPage,
        meta: {
            layout: 'main'
        }
    },
    {
        path: '/message/broadcast',
        name: 'BroadcastNotificationAdd',
        component: BroadcastNotificationAddPage,
        meta: {
            layout: 'main'
        }
    },
    {
        path: '/login',
        name: 'Login',
        component: LoginPage,
        meta: {
            layout: 'login'
        }
    },
    {
        path: '/logout',
        name: 'Logout',
        component: () => {
            // localStorage.removeItem('token')
            this.$store.dispatch('onLogout')
            router.push({'name': 'Login'})
        }
    },
    
]

const router = createRouter({
    history: createWebHistory(),
    routes
})


router.beforeEach((to, from, next) => {
    console.log(to, from, next)

    const isLoggedIn = store.getters.isLoggedIn

    console.log('isLoggedIn = ' + isLoggedIn)

    if (to.name !== 'Login' && !isLoggedIn) {
        next({name: 'Login'})
    } else if (to.name === 'Login' && isLoggedIn) {
        next({name: 'Home'})
    } else {
        next()
    }
})

export default router
